<template>
  <v-container>
    {{ lgLabel }}
    <v-row class="mt-0">
      <div
        v-for="(item, index) in items"
        :key="index"
      >
        <v-checkbox
          class="mx-4"
          v-model="selectedItems"
          :label="item.toUpperCase()"
          :value="slugify(item)"
        ></v-checkbox>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { slugify } from "@/utils/string"

export default {
  name: "Checkbox",
  props: {
    label: { type: String, default: "" },
    items: { type: Array, required: true },
    typename: { type: String },
    values: {
      type: Array,
      default: () => {
        return [{ checked: null }]
      }
    }
  },
  computed: {
    // lgLabel() {
    //   return `${this.label} - ${this.typename}`.toUpperCase()
    // },
    lgLabel() {
      return `${this.label}`.toUpperCase()
    },
    selectedItems: {
      get() {
        return this.toSelection(this.values)
      },
      set(newSelection) {
        this.$emit("input", this.toValues(newSelection))
      }
    }
  },
  methods: {
    slugify,
    toSelection(data) {
      return Object.entries(data[0])
        .filter(([key, value]) => key !== "id" && value == "1")
        .map(([key, value]) => key)
    },
    toValues(data) {
      return [
        {
          ...Object.fromEntries(
            this.items.map(e => {
              const key = slugify(e)
              return [key, data.includes(key) ? "1" : ""]
            })
          ),
          id: 0
        }
      ]
    }
  }
}
</script>
